import { Button } from "../ui/button";
import { CollectibleCard } from "./CollectibleCard";

export const CollectibleStoreSection = ({ items, onBuy, prefix = "store-collectible" }) => {
  if (!items.length) return null;
  return <section data-testid={`${prefix}-section`} className="space-y-5 mb-10">
    <h2 className="text-base md:text-lg font-semibold text-white">Digital collectibles</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">{items.map((item) => {
      const soldOut = item.sold_count + (item.reserved_count || 0) >= item.total_supply;
      return <CollectibleCard key={item.collectible_id} item={item} prefix={prefix}>
        <Button data-testid={`${prefix}-buy-${item.collectible_id}`} onClick={() => onBuy(item)} disabled={soldOut || !item.file_ready} className="w-full bg-[#EC008C] text-black hover:bg-[#FF3399]">{soldOut ? "Sold out" : "Review purchase"}</Button>
      </CollectibleCard>;
    })}</div>
  </section>;
};